import React from 'react'
import Permission from '../../../../utilities/auth/permission/Permission'

const PermissionContext = React.createContext<PermissionInterface | null>(null)

interface RoleProp {
  id: number
  value: string
}

interface PermissionProviderProps {
  permission: Permission
  role: RoleProp
}

interface PermissionInterface {
  permission: Permission
  roleId: number
  roleSlug: string
}

export function PermissionProvider({ children, permission, role }: React.PropsWithChildren<PermissionProviderProps>) {
  const val = {
    permission: permission,
    roleId: role.id,
    roleSlug: role.value,
  }
  return <PermissionContext.Provider value={val}>{children}</PermissionContext.Provider>
}

export function usePermission(): PermissionInterface {
  const context = React.useContext(PermissionContext)
  if (context === null) {
    throw new Error('usePermission must be used within a PermissionProvider')
  }
  return context
}
